// removed by extract-text-webpack-plugin
module.exports = {"submitFailed":"submitFailed___3C7mt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/SubmitFailed/styles.module.scss
// module id = 2246
// module chunks = 0